import PropTypes from 'prop-types'
import classNames from 'classnames'

import s from './LightboxButton.module.css'

function LightboxButton({ image = {}, onClick = () => {}, disabled = false }) {
  return (
    <button
      onClick={() => onClick(image.id, image.original_src, image.orientation)}
      className={classNames(s.container, 'lightboxButton')}
      disabled={disabled}
    >
      {disabled ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44">
          <defs>
            <circle id="b" cx="17" cy="17" r="17" />
            <filter
              id="a"
              width="141.2%"
              height="141.2%"
              x="-20.6%"
              y="-14.7%"
              filterUnits="objectBoundingBox"
            >
              <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
              <feGaussianBlur
                in="shadowOffsetOuter1"
                result="shadowBlurOuter1"
                stdDeviation="2"
              />
              <feColorMatrix
                in="shadowBlurOuter1"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
              />
            </filter>
          </defs>
          <g fill="none" fillRule="evenodd">
            <g transform="translate(5 4)">
              <use fill="#000" filter="url(#a)" xlinkHref="#b" />
              <use fill="#FFF" xlinkHref="#b" />
            </g>
            <path
              fill="#979797"
              fillRule="nonzero"
              d="M29.5 16l-8.749 9.12-4.418-4.32L15 22.5l5.751 5.5L31 17.44z"
            />
          </g>
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="42"
          height="42"
          viewBox="0 0 42 42"
        >
          <defs>
            <circle id="b" cx="17" cy="17" r="17" />
            <filter
              id="a"
              width="141.2%"
              height="141.2%"
              x="-20.6%"
              y="-14.7%"
              filterUnits="objectBoundingBox"
            >
              <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1" />
              <feGaussianBlur
                in="shadowOffsetOuter1"
                result="shadowBlurOuter1"
                stdDeviation="2"
              />
              <feColorMatrix
                in="shadowBlurOuter1"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
              />
            </filter>
            <path id="c" d="M0 5h11v2H0z" />
            <path id="d" d="M0 5h11v2H0z" />
          </defs>
          <g fill="none" fillRule="evenodd" transform="translate(4 2)">
            <use fill="#000" filter="url(#a)" xlinkHref="#b" />
            <use fill="#FFF" xlinkHref="#b" />
            <g transform="translate(12 11)">
              <use fill="#D8D8D8" xlinkHref="#c" />
              <path stroke="#979797" d="M.5 5.5h10v1H.5z" />
              <g transform="rotate(90 5.5 6)">
                <use fill="#D8D8D8" xlinkHref="#d" />
                <path stroke="#979797" d="M.5 5.5h10v1H.5z" />
              </g>
            </g>
          </g>
        </svg>
      )}
    </button>
  )
}

LightboxButton.propTypes = {
  image: PropTypes.object,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
}

export default LightboxButton
